<div class="date-range-picker-container">
  <nz-range-picker
    [(ngModel)]="value"
    (ngModelChange)="onDateRangeChange($event)"
    (nzOnOpenChange)="onOpenChangeHandler($event)"
    [nzFormat]="getFormat()"
    [nzShowTime]="getShowTimeConfig()"
    [nzInputReadOnly]="readonly"
    [nzDisabledDate]="nzDisabledDate"
    [nzAllowClear]="true"
    [nzSize]="'small'"
    [nzStatus]="getStatus()"
    [nzDisabled]="disabled"
  ></nz-range-picker>
</div>

